import { api } from '../../../api/index';
import { actions } from '../../../../store/actions/index';

export const deleteDriver = id => async dispatch => {
  try {
    await api.deleteDriver(id);
    dispatch(actions.deleteDriver.act(id));
    dispatch(actions.needToUpdateData.act(true));
  } catch (e) {
    return e;
  }
};
